<!--
 * @Description: 营销管理/平台营销工具/平台卡券活动/新客邀请活动记录
-->
<template>
  <scroll-layout>
    <template #header>
      <div v-if="pageButtons.length > 0" class="button-wrap">
        <ykc-button
          v-for="(button, index) in pageButtons"
          :key="button.id || index"
          v-bind="button"
          @click="button.handleClick(button, $event)">
          {{ button.text }}
        </ykc-button>
      </div>
      <div class="statistics-wrap">
        <div
          v-for="(item, index) in statisticsList"
          :key="index"
          class="statistics-card"
          :style="{ borderLeftColor: item.color }">
          <div class="statistics-info">
            <div class="statistics-label">{{ item.label }}</div>
            <div class="statistics-value" :style="{ color: item.color }">
              {{ statisticsData[item.key] || 0 }}
            </div>
          </div>
          <div class="statistics-icon" :style="{ backgroundColor: item.iconBg }">
            <i :class="item.icon" :style="{ color: item.color }"></i>
          </div>
        </div>
      </div>
      <ykc-search ref="YkcSearch" :data="searchItems" @click="handleSearchConfirm" />
    </template>
    <ykc-table
      ref="YkcTable"
      :data="tableData"
      :columns="tableColumns"
      :operateButtons="tableOperateButtons">
      <template #title>
        <div>
          <span class="ykc-table-header-title">{{ tableTitle }}</span>
        </div>
      </template>
      <template #headerButtons>
        <div class="table-header-button">
          <ykc-button type="plain" @click="exportBlob">导出</ykc-button>
        </div>
      </template>
      <ykc-pagination
        slot="pagination"
        ref="YkcPagination"
        :total="total"
        :current-page.sync="currentPage"
        @current-change="handlePaginationCurrentChange"
        :page-size.sync="pageSize"
        @size-change="handlePaginationSizeChange" />
    </ykc-table>
  </scroll-layout>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { couponActivity } from '@/service/apis';
  import { offlineExport } from '@/utils';

  export default {
    name: 'inviteActivityRecord',
    computed: {
      ...mapGetters([]),
    },
    data() {
      return {
        activityId: '',
        tableOperateButtons: [],
        pageButtons: [
          {
            id: '1',
            text: '返回',
            type: 'plain',
            handleClick: () => {
              this.$router.go(-1);
            },
          },
        ],
        statisticsData: {},
        statisticsList: [
          {
            label: '绑定中',
            key: 'bindingCount',
            color: '#10b981',
            iconBg: 'rgba(16, 185, 129, 0.1)',
            icon: 'el-icon-link',
          },
          {
            label: '已失效',
            key: 'expiredCount',
            color: '#ef4444',
            iconBg: 'rgba(239, 68, 68, 0.1)',
            icon: 'el-icon-remove-outline',
          },
          {
            label: '助力成功',
            key: 'supportSuccessCount',
            color: '#3b82f6',
            iconBg: 'rgba(59, 130, 246, 0.1)',
            icon: 'el-icon-circle-check',
          },
          {
            label: '总记录数',
            key: 'totalCount',
            color: '#374151',
            iconBg: 'rgba(55, 65, 81, 0.1)',
            icon: 'el-icon-s-data',
          },
        ],
        searchItems: [],
        tableData: [],
        tableColumns: [
          { label: '记录ID', prop: 'id', minWidth: '120px' },
          { label: '被邀请用户', prop: 'inviteePhone', minWidth: '120px' },
          { label: '发起邀请用户', prop: 'inviterPhone', minWidth: '120px' },
          { label: '活动名称', prop: 'activityName', minWidth: '160px' },
          { label: '类型', prop: 'activityType', minWidth: '80px' },
          {
            label: '绑定状态',
            prop: 'bindStatusText',
            minWidth: '80px',
            scopedSlots: {
              customRender: 'bindStatusText',
            },
          },
          { label: '邀请绑定时间', prop: 'inviteTime', minWidth: '160px' },
          { label: '绑定失效时间', prop: 'bindExpireTime', minWidth: '160px' },
          { label: '充电度数', prop: 'chargedPower', minWidth: '80px' },
          { label: '充电金额', prop: 'chargedAmount', minWidth: '80px' },
          {
            label: '充电达成状态',
            prop: 'supportStatusText',
            minWidth: '100px',
          },
          { label: '新客已发卡券', prop: 'newCustomerCoupon', minWidth: '160px' },
          { label: '老客已发卡券', prop: 'oldCustomerCoupon', minWidth: '160px' },
          { label: '最近充电时间', prop: 'inviteeLastChargeTime', minWidth: '140px' },
          { label: '充电站点', prop: 'inviteeLastStationName', minWidth: '140px' },
          { label: '省份', prop: 'inviteeProvinceName', minWidth: '80px' },
          { label: '城市', prop: 'inviteeCityName', minWidth: '80px' },
          { label: '最近充电时间（老客）', prop: 'inviterLastChargeTime', minWidth: '160px' },
          { label: '最近充电站点（老客）', prop: 'inviterLastStationName', minWidth: '160px' },
          { label: '省份（老客）', prop: 'inviterProvinceName', minWidth: '80px' },
          { label: '城市（老客）', prop: 'inviterCityName', minWidth: '80px' },
        ],
        tableTitle: '活动记录',
        total: 0,
        currentPage: 1,
        pageSize: 10,
        searchParams: {},
      };
    },
    created() {
      this.activityId = this.$route.query.activityId || '';

      this.searchItems = [
        {
          comName: 'YkcDatePicker',
          type: 'daterange',
          format: 'yyyy-MM-dd',
          key: 'bindTime',
          label: '绑定时间',
        },
        {
          comName: 'YkcInput',
          key: 'inviteeKeyword',
          label: '被邀请用户',
          placeholder: '请输入手机号',
        },
        {
          comName: 'YkcInput',
          key: 'inviterKeyword',
          label: '发起邀请用户',
          placeholder: '请输入手机号',
        },
        {
          comName: 'YkcDropdown',
          key: 'bindStatus',
          label: '绑定状态',
          placeholder: '请选择绑定状态',
          data: [
            { id: 1, name: '绑定中' },
            { id: 0, name: '已失效' },
          ],
          config: {
            label: 'name',
            value: 'id',
          },
        },
      ];

      this.getStatistics();
      this.getData();
    },
    methods: {
      getStatistics() {
        couponActivity.inviteBindRecordStatistics({ activityId: this.activityId }).then(res => {
          this.statisticsData = res || {};
        });
      },
      handleSearchConfirm(form) {
        this.currentPage = 1;
        const search = JSON.parse(JSON.stringify(form));
        if (search.bindTime && search.bindTime.length === 2) {
          [search.bindTimeStart, search.bindTimeEnd] = search.bindTime;
        }
        delete search.bindTime;
        this.searchParams = search || {};
        this.getData();
      },
      exportBlob() {
        offlineExport({
          downloadType: 'marketing_export',
          jsonNode: {
            downloadKey: 'invite_bind_record_export',
            activityId: this.activityId || '',
            ...this.searchParams,
          },
        });
      },
      handlePaginationCurrentChange(current) {
        this.currentPage = current;
        this.getData();
      },
      handlePaginationSizeChange(size) {
        this.currentPage = 1;
        this.pageSize = size;
        this.getData();
      },
      getData() {
        const reqData = {
          ...(this.searchParams || {}),
          current: this.currentPage,
          size: this.pageSize,
        };
        reqData.activityId = this.activityId || '';
        couponActivity.inviteBindRecordPage(reqData).then(res => {
          this.tableData = res.records || [];
          this.total = res.total;
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .statistics-wrap {
    display: flex;
    gap: 16px;
    margin-bottom: 16px;

    .statistics-card {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: #ffffff;
      border-radius: 4px;
      padding: 16px 20px;
      box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.06);
      border-left: 4px solid;

      .statistics-info {
        .statistics-label {
          font-size: 14px;
          color: #6b7280;
          margin-bottom: 8px;
        }

        .statistics-value {
          font-size: 28px;
          font-weight: 600;
          line-height: 1;
        }
      }

      .statistics-icon {
        width: 44px;
        height: 44px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;

        i {
          font-size: 20px;
        }
      }
    }
  }
</style>
